import React from 'react';
import { NavLink } from 'react-router-dom';
import CapriGlobalLogo from '../../../assets/capri-global-logo.svg';
import { company, routes, ui } from '../../models/content';
import V2AddressText from './V2AddressText';

function PhoneIcon() {
  return (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z" />
    </svg>
  );
}

function MailIcon() {
  return (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z" />
      <polyline points="22,6 12,13 2,6" />
    </svg>
  );
}

function MapPinIcon() {
  return (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z" />
      <circle cx="12" cy="10" r="3" />
    </svg>
  );
}

export default function V2Footer() {
  return (
    <footer className="site-footer">
      <div className="wrap">
        <div className="cols">
          <div className="col">
            <h4>Company</h4>
            <NavLink to={routes.about}>About Us</NavLink>
            <NavLink to={routes.fund}>Our Strategy</NavLink>
            <NavLink to={routes.teams}>Teams</NavLink>
            <NavLink to={routes.portfolio}>Our Portfolio</NavLink>
          </div>
          <div className="col">
            <h4>Insights</h4>
            <NavLink to={routes.news}>News and Media</NavLink>
          </div>
          <div className="col">
            <h4>Legal</h4>
            <NavLink to={routes.contact}>Get in Touch</NavLink>
            <NavLink to={routes.terms}>Terms and Conditions</NavLink>
            <NavLink to={routes.privacy}>Privacy Policy</NavLink>
          </div>
          <div className="col">
            <h4>Reach Us</h4>
            <div className="contact-line">
              <span className="icon" aria-hidden="true">
                <PhoneIcon />
              </span>
              <span>{company.phoneDisplay}</span>
            </div>
            <div className="contact-line">
              <span className="icon" aria-hidden="true">
                <MailIcon />
              </span>
              <span>{ui.footerEmailDisplay}</span>
            </div>
            <div className="contact-line">
              <span className="icon" aria-hidden="true">
                <MapPinIcon />
              </span>
              <span>
                <V2AddressText />
              </span>
            </div>
          </div>
        </div>

        <div className="baseline">
          <div>
            <img className="footer-logo" src={CapriGlobalLogo} alt={ui.brandName} />
          </div>
          <div className="copy">© 2026 {ui.brandName}. All rights reserved.</div>
        </div>
      </div>
    </footer>
  );
}
